export class LoginUser {

    public id: number;
    public username: string;
    private password: string;
    public email?: string;
    public roleId?: number;
    public employeeId?: number;
    public employeeName?: string;

    constructor(obj) {
        this.employeeId = obj.id;
        this.email = obj.email;
        this.username = obj.user_name;
        this.roleId = obj.user_role_id;
        this.id = obj.user_id;
        this.employeeName = obj.employee_name;
    }

    getPostData(){
        return {
            "user_name":this.username,
            "user_password": this.password
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/models/login-user-module.ts